// BT-112051 Creating tabs in Scrip Overview Analysis : ManasaB : 27/06/2023 - Start 
import { memo, useState, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { BzTabsContainer, BzTabs, BzTab } from '../../components';
import Technical from './Technical';
import Fundamental from './Fundamental';
import FutureOption from './FutureOption';
import { useSelector } from 'react-redux';
import { WATCHLIST_GRID_INDEX } from '../../utils/global_variables';

const Analysis = ({ handleMarketOverviewExpandOnclick, expandScripOverviewModel, setSelectedTab }) => {
    const [activeTabKey, setActiveTabKey] = useState('technical');
    // BT-109095: Functional Implementation : Vaibhav Singh : 26-07-2023 : Added F&O only visible for future scrips 
    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
    // Vaibhav S: 15-01-24: BT-109095: Technicl fixed- Start
    useEffect(() => {
        setActiveTabKey('technical');
    }, [scripOverviewData]);
    // Vaibhav S: 15-01-24: BT-109095: Technicl fixed- End
    return (
        <>
            <Container fluid className='p-0' >
                <Row className='g-0'>
                    {/* Bhagyashri P [16-11-2023] : BT-109095 - Scrip Overview Analysis logic updated for fundamental - Starts */}
                    <Col className='d-flex justify-content-center bdr-btm'>
                        <div className='submenu-wrapper'>
                            <BzTabs className='analysisTabs-wrap'>
                                <BzTab data-testid="market-overview-analysis-technical-tab" className='analysisTab' isActive={activeTabKey === 'technical' ? true : false} onClick={() => setActiveTabKey('technical')} tabKey='technical'>Technical</BzTab>
                                {(scripOverviewData[WATCHLIST_GRID_INDEX.SERIES]) ? <BzTab data-testid="market-overview-analysis-fundamental-tab" className='analysisTab' isActive={activeTabKey === 'fundamental' ? true : false} onClick={() => setActiveTabKey('fundamental')} tabKey='fundamental'>Fundamental</BzTab> : <BzTab data-testid="market-overview-analysis-fandO-tab" className='analysisTab' isActive={activeTabKey === 'FandO' ? true : false} onClick={() => setActiveTabKey('FandO')} tabKey='FandO'>F&O</BzTab>}
                            </BzTabs>
                        </div>
                    </Col>
                    {/* Bhagyashri P [16-11-2023] : BT-109095 - Scrip Overview Analysis logic upadted for fundamentals- Ends */}
                </Row>

                <BzTabsContainer>
                    {activeTabKey === 'technical' ?
                        <Technical expandScripOverviewModel={expandScripOverviewModel} setSelectedTab={setSelectedTab} />
                        : (
                            activeTabKey === 'fundamental' ?
                                // Vaibhav Singh: BT-116661: 28-08-2023: Expand button added
                                <Fundamental handleMarketOverviewExpandOnclick={handleMarketOverviewExpandOnclick} expandScripOverviewModel={expandScripOverviewModel} />
                                : (
                                    activeTabKey === 'FandO' ?
                                        <FutureOption />
                                        :
                                        null
                                )
                        )
                    }
                </BzTabsContainer>
            </Container>
        </>
    );
};

export default memo(Analysis);
// BT-112051 Creating tabs in Scrip Overview Analysis : ManasaB : 27/06/2023 - End